'use strict';

// Public key of the Shamir recovery service for sealed deposits of slice S (see seal.js).
// Pinned in the client bundle rather than fetched, so a deposit key can only change in a
// reviewed release. The private half lives only on the service. kid = first 16 hex of
// sha256(raw public key). Node tests pass their own key via registerFlow's opts.depositKey.
// shamir.smartledger.technology, generated on that box 2026-10-04 (GET /api/deposit-key).
const DEPOSIT_KEY = {
  kid: '3fb4e1ee6bb0a3c8',
  publicKey: 'BDydN9YY0EcTj8BgQQuHli5qnXqbL6XkOB_veHPWVCLi_MVh3hHf5e-Hsh7DggqyozuYLNqxcAI1YIkGVFlH568',
};

// Browser end-to-end tests run against a mock service with its own key. They may set
// window.__W3K_DEPOSIT_KEY, which is honoured ONLY on localhost: a production page always
// seals to the pinned key above.
function resolveDepositKey() {
  const g = globalThis;
  const host = g.location && g.location.hostname;
  if (g.__W3K_DEPOSIT_KEY && (host === 'localhost' || host === '127.0.0.1')) return g.__W3K_DEPOSIT_KEY;
  return DEPOSIT_KEY;
}

module.exports = { DEPOSIT_KEY, resolveDepositKey };
